<footer id="footer" class="cell shrink footer">
    <div class="cell small-12 bold medium-text-center large-text-right">
        ODNR Oil &amp; Gas Resources Management
    </div>
    <div class="cell small-12 medium-text-center large-text-right">
        {{address}}
        <span class="footer-separator fs1">|</span>
        {{city}}, Ohio {{zipCode}}
        <span class="footer-separator fs2">|</span>
        <span class="footer-phone-number">Phone: <a [href]="phoneHref">{{phoneFormatted}}</a></span>
    </div>
    <div class="cell small-12 medium-text-center large-text-left gov-dir">
        © Ohio DNR
        <span class="footer-separator fs3">|</span>
        <a href="http://www.governor.ohio.gov/" target="_blank" rel="noopener noreferrer">Governor, {{governor}}</a>
        <span class="footer-separator fs4">|</span>
        <a href="http://director.ohiodnr.gov" target="_blank" class="footer-director" rel="noopener noreferrer">Director, {{director}}</a>
    </div>
</footer>